var _excluded = ["key"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getTemplate, getUiOptions } from '@rjsf/utils';
/** The `ArrayFieldTemplate` component is the template used to render all items in an array.
 *
 * @param props - The `ArrayFieldTemplateItemType` props for the component
 */

export default function ArrayFieldTemplate(props) {
  var canAdd = props.canAdd,
      className = props.className,
      disabled = props.disabled,
      idSchema = props.idSchema,
      uiSchema = props.uiSchema,
      items = props.items,
      onAddClick = props.onAddClick,
      readonly = props.readonly,
      registry = props.registry,
      required = props.required,
      schema = props.schema,
      title = props.title;
  var uiOptions = getUiOptions(uiSchema);
  var ArrayFieldDescriptionTemplate = getTemplate('ArrayFieldDescriptionTemplate', registry, uiOptions);
  var ArrayFieldItemTemplate = getTemplate('ArrayFieldItemTemplate', registry, uiOptions);
  var ArrayFieldTitleTemplate = getTemplate('ArrayFieldTitleTemplate', registry, uiOptions); // Button templates are not overridden in the uiSchema

  var AddButton = registry.templates.ButtonTemplates.AddButton;
  return _jsxs("fieldset", {
    className: className,
    id: idSchema.$id,
    children: [_jsx(ArrayFieldTitleTemplate, {
      idSchema: idSchema,
      title: uiOptions.title || title,
      required: required,
      schema: schema,
      uiSchema: uiSchema,
      registry: registry
    }), _jsx(ArrayFieldDescriptionTemplate, {
      idSchema: idSchema,
      description: uiOptions.description || schema.description,
      schema: schema,
      uiSchema: uiSchema,
      registry: registry
    }), _jsx("div", {
      className: 'row array-item-list',
      children: items && items.map(function (_ref) {
        var key = _ref.key,
            itemProps = _objectWithoutProperties(_ref, _excluded);

        return _jsx(ArrayFieldItemTemplate, _objectSpread({}, itemProps), key);
      })
    }), canAdd && _jsx(AddButton, {
      className: 'array-item-add',
      onClick: onAddClick,
      disabled: disabled || readonly,
      uiSchema: uiSchema,
      registry: registry
    })]
  });
}